<template>
  <div :class="wrapperClasses">
    <remark-type-selector-button
      :selected="noteSelected"
      :label="noteLabel"
      :description="noteDescription"
      icon="icon-comment"
      @click="setNote"
    />
    <remark-type-selector-button
      :selected="todoSelected"
      :label="todoLabel"
      :description="todoDescription"
      icon="icon-bolt"
      @click="setTodo"
    />
  </div>
</template>

<script setup>
import { computed, defineModel } from 'vue'
import RemarkTypeSelectorButton from './remark-type-selector-button.vue'

const type = defineModel()

const noteLabel = I18n.t('communication.remark_form.note_label')
const todoLabel = I18n.t('communication.remark_form.todo_label')

const noteDescription = I18n.t('communication.remark_form.note_description')
const todoDescription = I18n.t('communication.remark_form.todo_description')

const noteSelected = computed(() => type.value === 'note')
const todoSelected = computed(() => type.value === 'todo')

const wrapperClasses =
  'tw-bg-sf-neutral-lighter-1 tw-rounded-md tw-flex tw-items-center tw-justify-between tw-p-1 tw-mb-4'

function setNote() {
  type.value = 'note'
}

function setTodo() {
  type.value = 'todo'
}
</script>
